<template>
    <v-dialog
        :value="isOpen"
        max-width="700px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Dodawanie numeru zlecenia
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="jobNumber"
                                :error-messages="jobNumberErrors"
                                label="Numer zlecenia"
                                required
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    :disabled="actionLoading"
                    @click="onClose()"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Potwierdź"
                    :loading="actionLoading"
                    @click="saveJobNumber()"
                >
                    Potwierdź
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'AddJobNumberDialog',
    props: {
        isOpen: {
            type: Boolean
        },
    },
    data() {
        return {
            jobNumber: null,
            actionLoading: false
        }
    },
    validations: {
        jobNumber: { required }
    },
    computed: {
        jobNumberErrors() {
            const errors = []

            if (!this.$v.jobNumber.$dirty) return errors
            !this.$v.jobNumber.required && errors.push('Proszę podać numer zlecenia.')

            return errors
        },
    },
    methods: {
        saveJobNumber() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.actionLoading = true
            this.$emit('on-confirm', this.jobNumber)
            this.onClose()
        },
        onClose() {
            setTimeout(() => {
                this.jobNumber = null
            }, 500)
            this.$v.$reset()
            this.actionLoading = false
            this.$emit('on-close')
        },
    }
}
</script>

